export let IframeQueryParameters = /*#__PURE__*/function (IframeQueryParameters) {
  IframeQueryParameters["nodeId"] = "nodeId";
  IframeQueryParameters["versionId"] = "versionId";
  IframeQueryParameters["referral"] = "referral";
  IframeQueryParameters["loadPageUrl"] = "loadPageUrl";
  IframeQueryParameters["applyUrlToRouter"] = "applyUrlToRouter";
  IframeQueryParameters["provideRuntimeDataFromSDK"] = "provideRuntimeDataFromSDK";
  return IframeQueryParameters;
}({});
export let AllowedUserActionRunners = /*#__PURE__*/function (AllowedUserActionRunners) {
  AllowedUserActionRunners["USP"] = "usp";
  return AllowedUserActionRunners;
}({});
//# sourceMappingURL=iframeQueryParameters.js.map